import Box from '@redbubble/design-system/src/Box';
import Skeleton from '@redbubble/design-system/src/Skeleton';
import React from 'react';

import styles from './LineItem.module.scss';
import removeBtnStyles from './RemoveButton/RemoveButton.module.scss';

interface LoadingLineItemProps {
  narrow?: boolean;
}

export const LoadingLineItem = ({ narrow }: LoadingLineItemProps) => {
  return (
    <Box
      element="li"
      className={[styles.wrapper, narrow && styles.narrow]
        .filter(Boolean)
        .join(' ')}
    >
      <Box className={styles.content}>
        <Box className={styles.image}>
          <Skeleton
            height={128}
            width={128}
            animated
            roundedCorners
            data-testid="line-item-loading"
          />
        </Box>
        <Box className={styles.details}>
          <Box className={styles.loadingDetails}>
            <Skeleton height={24} animated roundedCorners />
          </Box>
          <Box className={styles.loadingDetails}>
            <Skeleton height={16} width="75%" animated roundedCorners />
          </Box>
          <Box className={styles.loadingDetails}>
            <Skeleton height={16} width="75%" animated roundedCorners />
          </Box>
        </Box>
        <Box className={styles.quantity}>
          <Skeleton height={32} width={100} animated roundedCorners />
        </Box>
        <Box className={styles.price} style={{ minWidth: '50px' }}>
          <Skeleton height={32} width="100%" animated roundedCorners />
        </Box>
        <Box className={removeBtnStyles.removeBtnWrapper}>
          <Skeleton height={32} animated circular />
        </Box>
      </Box>
    </Box>
  );
};
